

export const getAvatarFromName = (name: string): string => {
  if (name) {
    let firstLetters: string[];
    if (name.includes(',')) {
      firstLetters = name
        .split(',')
        .map(word => word.trim()[0])
        .reverse();
    } else if (name.trim().includes(' ')) {
      firstLetters = name.split(' ').map(word => word[0]);
    } else {
      return name
        .trim()
        .slice(0, 2)
        .toUpperCase();
    }

    return firstLetters.length > 1 ? `${firstLetters[0].toUpperCase()}${firstLetters[1].toUpperCase()}` : undefined;
  }
  return undefined;
};

const ibanLetterConverter = (letter: string) => {
  const lsLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return lsLetters.search(letter) + 10;
};

const validateCCC = (val: string) => {
  const bank = val.substring(0, 4);
  const office = val.substring(4, 8);
  const cd = val.substring(8, 10);
  const account = val.substring(10, 20);
  const zbs = `00${bank}${office}`;

  if (!/^[0-9]{20}$/.test(bank + office + cd + account)) return false;

  const values = [1, 2, 4, 8, 5, 10, 9, 7, 3, 6];
  let control = 0;
  for (let i = 0; i <= 9; i += 1) {
    control += parseInt(account.charAt(i), 10) * values[i];
  }
  control = 11 - (control % 11);
  if (control === 11) control = 0;
  else if (control === 10) control = 1;
  if (control !== parseInt(cd.charAt(1), 10)) {
    return false;
  }

  control = 0;

  for (let i = 0; i <= 9; i += 1) {
    control += parseInt(zbs.charAt(i), 10) * values[i];
  }
  control = 11 - (control % 11);
  if (control === 11) control = 0;
  else if (control === 10) control = 1;
  if (control !== parseInt(cd.charAt(0), 10)) {
    return false;
  }
  return true;
};

export const validateIBAN = account => {
  if (!account) return true;
  const countryCode = account.slice(0, 2);
  const controlCode = account.slice(2, 4);
  const ccc = account.slice(4, account.length);

  const cccToCalculate = `${ccc}${ibanLetterConverter(countryCode[0])}${ibanLetterConverter(countryCode[1])}00`;

  let mod = 0;
  /* eslint no-restricted-syntax: 0 */
  for (const num of cccToCalculate) {
    mod = (mod * 10 + Number(num)) % 97;
  }
  const calculatedCode = (98 - mod).toString().length === 1 ? `0${(98 - mod).toString()}` : (98 - mod).toString();
  return validateCCC(ccc) && calculatedCode === controlCode;
};

export const validateIBANPortugal = (entity: string, office: string, dc: string, account: string): boolean => {
  const pinNib = entity + office + account + dc;
  let total = 0;
  for (let index = 0; index <= 18; index++) {
    const digito = parseInt(pinNib.slice(index, index + 1), 10);
    total = ((total + digito) * 10) % 97;
  }
  total = 98 - ((total * 10) % 97);
  if (total !== parseInt(dc, 10)) {
    return false;
  }
  return true;
};

const isObject = (object: any) => {
  return object != null && typeof object === 'object';
};
